//
//
//
//

var orders = {
  // 升序
  1: 'ascending',
  // 降序
  2: 'descending',
  // 默认
  3: 'default'
};
export default {
  props: {
    sortProp: {
      type: String
    }
  },
  data: function data() {
    return {
      count: 0
    };
  },
  methods: {
    handleFilter: function handleFilter() {
      this.count++;
      this.$emit('on-filter', {
        prop: this.sortProp,
        order: orders[this.count]
      });
      if (this.count > 2) {
        this.count = 0;
      }
    }
  }
};